import { metaMaskId, wcId } from 'connection/wallet-connect/adapters'
import { createStore } from 'mipd'

import { ADAPTERS } from './constants'
import { filterAdapters, getWalletsData } from './utils'

export const providersStore = createStore()

export interface WalletConfig {
  walletconnectProjectId: string
  walletsShown?: Array<keyof typeof ADAPTERS>
}

const WALLETS_SHOWN_CONFIG_DEFAULT = Object.keys(ADAPTERS) as Array<keyof typeof ADAPTERS>

export const configureWallets = ({ walletsShown = [metaMaskId, wcId], ...config }: WalletConfig) => {
  const isDefaultShown = walletsShown === WALLETS_SHOWN_CONFIG_DEFAULT

  return getWalletsData(isDefaultShown ? ADAPTERS : filterAdapters(ADAPTERS, walletsShown), {
    walletconnectProjectId: config.walletconnectProjectId,
    providersStore,
  })
}
